import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { BlameLogType } from '@debbie/common/dist/blamelog/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useBillingModels } from '@debbie/cortex/dist/billing-models/index.js';
import { selectProcedures } from '@debbie/cortex/dist/procedures/selectors.js';
import { selectWorkflows } from '@debbie/cortex/dist/workflows/selectors.js';
import { Table } from '../../index.js';
import ButtonDrop from '../../ButtonDrop.js';
import { Meta } from './style.js';
import { useUserById } from '@debbie/cortex/dist/users/index.js';
export const SettingsDetails = (props) => {
    const lang = useSelector((s) => s.lang);
    const [showSettingOpen, setShowSettingOpen] = useState(false);
    const billingModelsLoadable = useBillingModels();
    const billingModels = h.hasData(billingModelsLoadable)
        ? billingModelsLoadable.data
        : null;
    const userLoader = useUserById(props.details.userId);
    const user = h.hasData(userLoader) ? userLoader.data : null;
    const procedures = useSelector(selectProcedures);
    const selectedProcedure = procedures && props.type === BlameLogType.TriggerShortcut
        ? procedures.find((p) => p.procedureId === props.details.procedureId)
        : props.details.procedure;
    const billingModel = props.type === BlameLogType.ConnectorBillingUpdate
        ? billingModels?.find((billingModel) => billingModel.billingModelId === props.details.billingModelId)
        : null;
    const workflows = useSelector(selectWorkflows);
    return (React.createElement(ButtonDrop, { open: showSettingOpen, onOpen: () => setShowSettingOpen(true), onClose: () => setShowSettingOpen(false), size: "mini", info: true, maxWidth: "500px", minWidth: "500px" },
        React.createElement(Meta, null,
            React.createElement(Table, { zebra: true },
                typeof props.details.toggled !== 'undefined' &&
                    props.details.toggled !== null && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.toggled)),
                    React.createElement("td", null, props.details.toggled
                        ? lang.blameLogs.trueActivated
                        : lang.blameLogs.falseActivated))),
                props.details.keyChanged && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.key)),
                    React.createElement("td", null, props.details.keyChanged
                        ? lang.blameLogs.trueChanged
                        : lang.blameLogs.falseChanged))),
                props.details.codeChanged && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.code)),
                    React.createElement("td", null, props.details.codeChanged
                        ? lang.blameLogs.trueChanged
                        : lang.blameLogs.falseChanged))),
                props.details.usernameChanged && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.username)),
                    React.createElement("td", null, props.details.usernameChanged
                        ? lang.blameLogs.trueChanged
                        : lang.blameLogs.falseChanged))),
                props.details.passwordChanged && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.password)),
                    React.createElement("td", null, props.details.passwordChanged
                        ? lang.blameLogs.trueChanged
                        : lang.blameLogs.falseChanged))),
                props.details.clientId && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.experianClientId)),
                    React.createElement("td", null, lang.blameLogs.trueChanged +
                        ` ${lang.blameLogs.to}: ` +
                        props.details.clientId))),
                props.details.priceList?.RKIRegistrationFee && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.tenants.RKIRegistrationFee)),
                    React.createElement("td", null, lang.blameLogs.trueChanged +
                        ` ${lang.blameLogs.to}: ` +
                        props.details.priceList.RKIRegistrationFee))),
                props.details.priceList?.afslysningAfUdlaeg && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.tenants.afslysningAfUdlaeg)),
                    React.createElement("td", null, lang.blameLogs.trueChanged +
                        ` ${lang.blameLogs.to}: ` +
                        props.details.priceList.afslysningAfUdlaeg))),
                props.details.priceList?.anmeldelseAfKravFee && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.tenants.anmeldelseAfKravFee)),
                    React.createElement("td", null, lang.blameLogs.trueChanged +
                        ` ${lang.blameLogs.to}: ` +
                        props.details.priceList.anmeldelseAfKravFee))),
                props.details.priceList?.caseCloseFee && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.tenants.caseCloseFee)),
                    React.createElement("td", null, lang.blameLogs.trueChanged +
                        ` ${lang.blameLogs.to}: ` +
                        props.details.priceList.caseCloseFee))),
                props.details.priceList?.clientCaseCreationFee && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.tenants.clientCaseCreationFee)),
                    React.createElement("td", null, lang.blameLogs.trueChanged +
                        ` ${lang.blameLogs.to}: ` +
                        props.details.priceList.clientCaseCreationFee))),
                props.details.priceList?.fogedrekvisitionsFee && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.tenants.fogedrekvisitionFee)),
                    React.createElement("td", null, lang.blameLogs.trueChanged +
                        ` ${lang.blameLogs.to}: ` +
                        props.details.priceList.fogedrekvisitionsFee))),
                props.details.priceList?.folkeregisteropslagsFee && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.tenants.folkeregisteropslagsFee)),
                    React.createElement("td", null, lang.blameLogs.trueChanged +
                        ` ${lang.blameLogs.to}: ` +
                        props.details.priceList.folkeregisteropslagsFee))),
                props.details.priceList?.legalAdviceHourlyRate && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.tenants.legalAdviceHourlyRate)),
                    React.createElement("td", null, lang.blameLogs.trueChanged +
                        ` ${lang.blameLogs.to}: ` +
                        props.details.priceList.legalAdviceHourlyRate))),
                props.details.priceList?.paymentDemandFee && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.tenants.paymentDemandFee)),
                    React.createElement("td", null, lang.blameLogs.trueChanged +
                        ` ${lang.blameLogs.to}: ` +
                        props.details.priceList.paymentDemandFee))),
                props.details.priceList?.tenantCaseCreationFee && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.tenants.tenantCaseCreationFee)),
                    React.createElement("td", null, lang.blameLogs.trueChanged +
                        ` ${lang.blameLogs.to}: ` +
                        props.details.priceList.tenantCaseCreationFee))),
                user && user.firstName && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.users.firstName)),
                    React.createElement("td", null, user.firstName))),
                user && user.lastName && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.users.lastName)),
                    React.createElement("td", null, user.lastName))),
                user && user.email && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.users.email)),
                    React.createElement("td", null, user.email))),
                props.details.systemProcedure && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.when)),
                    React.createElement("td", null, lang.triggers[props.details.systemProcedure]))),
                props.details.systemProcedure && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.procedure)),
                    React.createElement("td", null, selectedProcedure
                        ? selectedProcedure.title
                        : lang.blameLogs.removed))),
                props.details.workflowId && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.workflow)),
                    React.createElement("td", null, workflows?.find((wf) => wf.workflowId === props.details.workflowId)?.title))),
                props.details.workflowType && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.type)),
                    React.createElement("td", null, props.details.workflowType === 'default'
                        ? lang.creditors.defaultChain
                        : lang.creditors.defaultClientChain))),
                typeof props.details.dunning !== 'undefined' &&
                    props.details.dunning !== null && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.dunning)),
                    React.createElement("td", null, props.details.dunning
                        ? lang.blameLogs.trueYes
                        : lang.blameLogs.falseNo))),
                props.details.billingModelId && billingModel && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.connectorBillingModel)),
                    React.createElement("td", null, billingModel.name))),
                props.type === BlameLogType.CreditorSettingsUpdate &&
                    Object.keys(props.details).map((key) => {
                        return (React.createElement("tr", { key: key },
                            React.createElement("td", null,
                                React.createElement("b", null, 
                                // @ts-ignore
                                lang.creditors[key] || `${key}`)),
                            React.createElement("td", null, JSON.stringify(props.details[key]))));
                    })))));
};
//# sourceMappingURL=SettingsDetails.js.map